<template>
    <SebraePortalMorphLoader v-bind="$attrs" />
</template>

<script>
import { SebraePortalMorphLoader } from '@packages/design-system';

export default {
    name: 'PortalMorphLoader',
    components: { SebraePortalMorphLoader },
    inheritAttrs: false,
};
</script>
